<template lang="pug">
BriqTable.edit-deal-products-table
  thead
    th.order Order
    th.product Product
    th.dealproduct-type-base.relative
      span Base
      briq-tooltip(help="Products that are always part of the deal")
    th.dealproduct-type-extra.relative
      span Extra
      briq-tooltip(help="Customers can choose if they want to add this product")
    th.quantity-pp Quantity (p.p.)
    th.price-type Price Type
    th.base-price Base price
    th.price-change Price change
    th.remove-action(v-if="!forEditProduct")
  draggable(
    v-if="!forEditProduct"
    tag="tbody"
    :list="dealProducts"
    id="product-group-products"
    handle=".handle"
    v-bind="dragOptions"
    @end="reorder"
    )
    DealProductsTableRow(
      v-for="(dealProduct, index) in dealProducts"
      :dealProduct="dealProduct"
      :key="index"
      :productIndex="index"
      :pending="pending"
      @remove="p => $emit('removeProduct', p)"
      @dealProductPriceOffsetInput="v => $emit('dealProductPriceOffsetInput', v)"
      )
  DealProductsTableRow(
    v-else 
    v-for="(dealProduct, index) in dealProducts"
    :dealProduct="dealProduct"
    :key="index"
    :productIndex="index"
    :forEditProduct="forEditProduct"
    :editProductKey="editProductKey"
    :pending="pending"
    @remove="p => $emit('removeProduct', p)"
    @dealProductPriceOffsetInput="v => $emit('dealProductPriceOffsetInput', v)"
    )
</template>

<script>
import DealProductsTableRow from './DealProductsTableRow.vue'
import draggable from 'vuedraggable'

export default {
  name: 'DealProductsTable',
  components: { DealProductsTableRow, draggable },
  props: {
    dealProducts: { type: Array, required: true },
    forEditProduct: Boolean,
    editProductKey: String,
    pending: Boolean,
  },
  data() {
    return {
      dragging: false,
      dragOptions: {
        animation: 200,
        group: 'description',
        disabled: false,
      },
      productTypeHelptext:
        'Base products are part of the deal. Extra products can be added optionally to the deal by the customer during the checkout process in the webshop.',
    }
  },
  methods: {
    reorder() {
      this.dealProducts?.forEach((product, index) => {
        product.ProgramOrder = index + 1
      })
    },
  },
  updated() {
    this.reorder()
  },
  mounted() {
    this.reorder()
  },
}
</script>

<style scoped lang="stylus">
.edit-deal-products-table
  thead
    .order
      width 5%
    .product
      width 20%
    .dealproduct-type-base
      width 8%
    .dealproduct-type-extra
      width 8%
    .quantity-pp
      width 3%
    .price-type
      width 15%
    .base-price
      width 11%
    .price-change
      width 23%
    .remove-action
      width 8%

.relative
   position relative
</style>
